import {DataFetcher} from '@aboutyou/data-fetcher';
import React, {Fragment, useEffect} from 'react';
import {useSizesSection} from '../ProductInformationBox/MiniArticleDetail/useGetMinimalProductBulkSection';
import {AddToBasketSectionSkeleton} from './AddToBasketSectionSkeleton';
import {
  AddToBasketSectionView,
  AddToBasketSectionViewProps,
} from './AddToBasketSectionView';
import {MoreDetails} from './MoreDetails/MoreDetails';

export const AddToBasketSectionMinimal = (
  props: Omit<AddToBasketSectionViewProps, 'isInMiniADPDialog'> & {
    productId: number;
    replaceHistory?: boolean;
    ref?: React.Ref<HTMLElement>;
  },
) => {
  const {ref} = props;
  // reset selected size when the product data is refreshed (after being stale)
  // and only if the selected size is soldOut
  useEffect(() => {
    if (props.selectedSize?.availability?.$case === 'soldOut') {
      props.setSelectedSize(undefined);
    }
  }, [props.selectedSize, props.selectedSize?.availability?.$case]);

  return (
    <DataFetcher
      request={useSizesSection(props.productId, {
        selectedSize: props.selectedSize,
        setSelectedSize: props.setSelectedSize,
      })}
      Error={() => null}
      Loading={AddToBasketSectionSkeleton}
      View={viewProps => (
        /**
         * Ideally, the `MoreDetails` should be its own dedicated component, making its own request
         * to get the data. However as we don't have a dedicated section in the adp bulk response we
         * decided to put it here as it belongs in the same block from a UI perspective.
         */
        <Fragment>
          <AddToBasketSectionView {...viewProps} isInMiniADPDialog />
          <MoreDetails
            replaceHistory={viewProps.replaceHistory}
            {...viewProps}
          />
        </Fragment>
      )}
      viewProps={{...props, ref}}
    />
  );
};
